import {FetchVenuesResponse as Address} from '../services'

export const kegstarCollectionEmailAddress = (
  chosenLocation: Address | null,
  chosenLocationLocalState: Address | null
) => {
  let emailAddress = 'collections@kegstar.com'
  if (chosenLocation?.country === 'AU' || chosenLocationLocalState?.country === 'AU') {
    emailAddress = 'rent@kegstar.com'
  }
  if (chosenLocation?.country === 'NZ' || chosenLocationLocalState?.country === 'NZ') {
    emailAddress = 'rent@kegstar.com'
  }
  return emailAddress
}
